"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoalSubtype = void 0;
exports.GoalSubtype = Object.freeze({
    Goal: 'goal',
    HorizontalBullet: 'horizontalBullet',
    VerticalBullet: 'verticalBullet',
});
//# sourceMappingURL=constants.js.map